// extracted by mini-css-extract-plugin
export default {"noDataFallback":"NoDataFallback_noDataFallback__mATQo","imageWrapper":"NoDataFallback_imageWrapper__diu0p","text":"NoDataFallback_text__1QvI8"};